import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataEntity_Detail_06_Interface } from 'src/app/Interface/DataEntity/06/DataEntity_Detail_06_Interface';
import { DataEntity_Main_06_Interface } from 'src/app/Interface/DataEntity/06/DataEntity_Main_06_Interface';
import { DataEntity_Resolution_06_Interface } from 'src/app/Interface/DataEntity/06/DataEntity_Resolution_06_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataEntity06Service {

  constructor(private http: HttpClient) { }

  GetSingle(Token: String,
    id: Number,
    dataentity_id: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Dataentityno06/GetSingle?token=" + Token
      + "&id=" + id
      + "&dataentity_id=" + dataentity_id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  Submit(
    model_temp: DataEntity_Main_06_Interface,
    detail: Array<DataEntity_Detail_06_Interface>,
    resolution: Array<DataEntity_Resolution_06_Interface>,

    DataEntity_id: number,
    Calibration_Id: number,
    Filename: string,

    FolderName: string,

    Capability: string,
    DeviceSerial: string,
    DeviceCode: string,

    Manufacture_txt: String,
    Type_txt: String,
    Model_txt: String,
    LabAddress_txt: String,


    Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var detail_list = []
    var mesured_list = []


    for (let item of detail) {
      detail_list.push({
        id: item.id,
        main_id: model_temp.id,

        converage: item.converage,
        sample: item.sample,
        reference_up: item.reference_up,
        reference_down: item.reference_down,
        uncertainty: item.uncertainty,

        before: item.before,
      })
    }

    var model={
      id:model_temp.id,
      filename: Filename,

      pdf_src: FolderName,

      manufacture: Manufacture_txt,
      type: Type_txt,
      model: Model_txt,

      capability: Capability,

      working_max: model_temp.working_max,
      working_min: model_temp.working_min,
      accuracy: model_temp.accuracy,



      unit_working: model_temp.unit_working,
      unit_reference: model_temp.unit_reference,
      unit_indication: model_temp.unit_indication,
      unit_deviation: model_temp.unit_deviation,
      unit_uncertainty: model_temp.unit_uncertainty,
      unit_correction_eqution: model_temp.unit_correction_eqution,

      temperature_Air_before: model_temp.temperature_Air_before +'',
      temperature_Air_after: model_temp.temperature_Air_after+'',

      humidity_Air_before: model_temp.humidity_Air_before+'',
      humidity_Air_after: model_temp.humidity_Air_after+'',

      pressure_before: model_temp.pressure_before+'',
      pressure_after: model_temp.pressure_after+'',

      working_type: Number(model_temp.working_type),
    }

    var body = {
      Calibration_id: Calibration_Id,
      model: model,
      resolution : resolution,

      detail: detail_list,
      mesured: mesured_list,
      DeviceSerial: DeviceSerial,
      DeviceCode: DeviceCode,
      Token: Token,
      labAdderss: LabAddress_txt,
      dataentity_id: DataEntity_id,
    }


    return this.http.post(environment.BaseUrl + "Daro/Dataentityno06/Submit", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  uploadFile(body,deviceName:String,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno06/upload?token="+Token+"&deviceName="+deviceName,body).pipe(
      map(data=>{
        return data
      })
    )
  }

  uploadPdf(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno06/uploadPdf?token="+Token,body).pipe(
      map(data=>{
        return data
      })
    )
  }


}
